import { render, staticRenderFns } from "./StrapiSortableHeader.vue?vue&type=template&id=3d1c3371&scoped=true&"
import script from "./StrapiSortableHeader.vue?vue&type=script&lang=js&"
export * from "./StrapiSortableHeader.vue?vue&type=script&lang=js&"
import style0 from "./StrapiSortableHeader.vue?vue&type=style&index=0&id=3d1c3371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c3371",
  null
  
)

export default component.exports